import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ isVisible, onBarFull }) => {
  return (
    <div className={`loading-screen${isVisible ? '' : ' loaded'}`}>
      <div className="loading-content">
        <div className="logo-container">
          <img src="/logo-1.avif" alt="Elyspr Logo" className="loading-logo" />
        </div>
        <h1>
          <span className="loading-line">
            loading
            <span className="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </span>
        </h1>
        <div className="underline" onAnimationEnd={onBarFull}></div>
      </div>
    </div>
  );
};

export default LoadingScreen; 